import { useContext, useEffect } from 'react';
import { useParams } from 'react-router';

import { CUBOH_COMPANY_PREFIX } from 'constants/path';
import { HeadquarterContext } from 'context/HeadquarterContext';
import { removeCubohPrefix } from 'helpers/company';
import { useAuth } from 'hooks/useAuth';
import { setSharedEventAttributes } from 'helpers/mparticle';

export function useMParticleSharedAttributes() {
  const { headquarter, location, cubohCompany } = useContext(HeadquarterContext) ?? {};
  const { restaurantId } = useParams();
  const { user } = useAuth();

  // Prefer the URL: context ids arrive a fetch later, after the page view has fired.
  // CN-51322.
  const isCubohRoute = !!restaurantId?.startsWith(CUBOH_COMPANY_PREFIX);
  const cubohCompanyId = isCubohRoute ? removeCubohPrefix(restaurantId) : undefined;

  const groupId = user?.group_id;
  // Cuboh routes never reach the company fetch; `user.company_id` is what it resolves from.
  const brandId = headquarter?.id ?? user?.company_id;
  // ...nor the location fetch, so only a dual account can supply a CN id.
  const locationId = isCubohRoute
    ? cubohCompany?.chownow_restaurant_id
    : (restaurantId ?? location?.id);

  useEffect(() => {
    setSharedEventAttributes({
      group_id: groupId,
      restaurant_brand_id: brandId,
      restaurant_location_id: locationId,
      cuboh_company_id: cubohCompanyId,
    });
  }, [groupId, brandId, locationId, cubohCompanyId]);
}

export function MParticleSharedAttributesSync() {
  useMParticleSharedAttributes();
  return null;
}
